import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL_LOCAL;
export const login = createAsyncThunk(
  "user/login",
  async (params) => {
    // const response = await signInWithEmailAndPassword(auth, params.email, params.password);
    // return response;
    try {
      const data = await axios.post(`${API_URL}/api/login`, { email: params.email, password: params.password });

      if (data?.data) {
        // localStorage.setItem("isRemember", JSON.stringify(body.rememberMe));
        return data;
      }
      return null;
    }
    catch (error) {
      console.log(error)
    }
  });


export const changePassword = createAsyncThunk(
  "user/changePassword",
  async (params) => {
    // const config = {
    //   headers: {
    //     Authorization: localStorage.getItem("token"),
    //   }
    // };
    // const response = await axios.post(
    //   `${APIURL}/changePassword`,
    //   params,
    //   config
    // );

    // return response;
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    // user: localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : {},
    token: localStorage.getItem('token') ? localStorage.getItem('token') : "",
    userLoggedIn: false,
    Activeusers: 0,
    Inactiveusers: 0,
    Activeposts: 0,
    Inactiveposts: 0,
    Reportedposts: 0,
    todayTotalUsers: 0,
    todayNewusers: 0,
    last30DaysTotalUsers: 0,
    last30DaysNewUsers: 0
  },
  reducers: {},
  extraReducers: (builder) => {

    builder.addCase(login.fulfilled, (state, action) => {
      // if (action?.payload?.user?.email === 'admin-tattoapp@yopmail.com') {
      state.user = action?.payload?.data?.data?.user;
      state.userLoggedIn = true;
      // localStorage.setItem('userData', JSON.stringify(action?.payload?.user))
      localStorage.setItem('token', action?.payload?.data?.data?.token);
      // }
    });
  },
});

export default authSlice.reducer;
